import {breakpointDown} from "../utils/breakpoints";
import { gsap } from 'gsap'
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);


window.setupAccordionEventListeners = () => {
  $(document).off('click', '.js-accordion-title');
  $('body').on('click','.js-accordion-title', function () {
    let accordionContainer = $(this).closest('.js-accordion');
    let curEl = $(this).parent();
    let video = curEl.find('video');

    if (video.length) video[0].play();

    curEl.toggleClass('opened');
    curEl.find('.js-accordion-content').slideToggle();

    // close other accordions
    if (accordionContainer.length) {
      accordionContainer.find('.js-accordion-el').each(function (i, el) {
        if (el !== curEl[0]) {
          $(el).removeClass('opened');
          $(el).find('.js-accordion-content').slideUp();

          let video = $(el).find('video');
          if (video.length) {
            video[0].pause();
            video[0].currentTime = 0;
          }
        }
      });
    }

    if (breakpointDown('md')) {
      setTimeout(function(){
        gsap.to(window, {duration: 0.4, scrollTo: curEl[0]});
      }, 400);
    }
  });
}

$(document).ready(function() {
  setupAccordionEventListeners();
});
